export default "__VITE_ASSET__DyM4MYkd__"